module.exports = __webpack_public_path__ + "img/icon_goods.fb5a2f78.png";